import React from "react";
import { Card } from "react-bootstrap";
import { Attribute, AttributeGroup, Option, ProductFormValues } from "../types";
import { FileAttachment as CustomFileAttachment } from "components/custom/types";
import ProductAttributeField from "./ProductAttributeField";
import { useTranslation } from "react-i18next";

interface ProductAttributeGroupProps {
  group: AttributeGroup;
  formValues: ProductFormValues;
  invalidFields: string[];
  isLoadingOptions: boolean;
  dynamicOptions: { [key: string]: Option[] };
  brandOptions?: Option[];
  onInputChange: (query: string, attribute: Attribute) => void;
  onChange: (attribute_code: string, value: any) => void;
  onFileDrop?: (files: any[]) => void;
  onFileRemove?: (fileName: string) => void;
  onFileUpdate?: (index: number, updatedData: Partial<CustomFileAttachment>) => void;
  onFileIndexChange?: (fromIndex: number, toIndex: number) => void;
  onCategorySelected?: (selectedCategory: any) => void;
  fetchCategories?: () => Promise<any[]>;
  initialCategorySelection?: any;
}

const ProductAttributeGroup: React.FC<ProductAttributeGroupProps> = ({
  group,
  formValues,
  invalidFields,
  isLoadingOptions,
  dynamicOptions,
  brandOptions,
  onInputChange,
  onChange,
  onFileDrop,
  onFileRemove,
  onFileUpdate,
  onFileIndexChange,
  onCategorySelected,
  fetchCategories,
  initialCategorySelection,
}) => {
  // Log the initial category selection if provided
  React.useEffect(() => {
    if (initialCategorySelection) {
      console.log("[ProductAttributeGroup] Initial category selection:", initialCategorySelection);
    }
  }, [initialCategorySelection]);
  // Skip if group's attributes is a string instead of an array
  if (typeof group.attributes === "string") {
    return null;
  }

  return (
    <div className="mb-4">
      {group.attributes.map((attribute: Attribute) => (
        <ProductAttributeField
          key={attribute.attribute_id}
          attribute={attribute}
          formValues={formValues}
          invalidFields={invalidFields}
          isLoadingOptions={isLoadingOptions}
          dynamicOptions={dynamicOptions}
          brandOptions={brandOptions}
          onInputChange={onInputChange}
          onChange={onChange}
          onFileDrop={onFileDrop}
          onFileRemove={onFileRemove}
          onFileUpdate={onFileUpdate}
          onFileIndexChange={onFileIndexChange}
          onCategorySelected={onCategorySelected}
          fetchCategories={fetchCategories}
          initialCategorySelection={initialCategorySelection}
        />
      ))}
    </div>
  );
};

export default ProductAttributeGroup;
